// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsOccupancy_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 9C13.1046 9 14 8.10457 14 7 14 5.89543 13.1046 5 12 5 10.8954 5 10 5.89543 10 7 10 8.10457 10.8954 9 12 9ZM9 14C9 15.1046 8.10457 16 7 16 5.89543 16 5 15.1046 5 14 5 12.8954 5.89543 12 7 12 8.10457 12 9 12.8954 9 14ZM12 13C12.5523 13 13 12.5523 13 12 13 11.4477 12.5523 11 12 11 11.4477 11 11 11.4477 11 12 11 12.5523 11.4477 13 12 13ZM20 24C20 22.8954 20.8954 22 22 22 23.1046 22 24 22.8954 24 24 24 25.1046 23.1046 26 22 26 20.8954 26 20 25.1046 20 24ZM11 22C9.89543 22 9 22.8954 9 24 9 25.1046 9.89543 26 11 26 12.1046 26 13 25.1046 13 24 13 22.8954 12.1046 22 11 22ZM13 18C13 16.8954 13.8954 16 15 16 16.1046 16 17 16.8954 17 18 17 19.1046 16.1046 20 15 20 13.8954 20 13 19.1046 13 18ZM23 12C21.8954 12 21 12.8954 21 14 21 15.1046 21.8954 16 23 16 24.1046 16 25 15.1046 25 14 25 12.8954 24.1046 12 23 12ZM19 20C19 19.4477 19.4477 19 20 19 20.5523 19 21 19.4477 21 20 21 20.5523 20.5523 21 20 21 19.4477 21 19 20.5523 19 20ZM19 6C18.4477 6 18 6.44772 18 7 18 7.55228 18.4477 8 19 8 19.5523 8 20 7.55228 20 7 20 6.44772 19.5523 6 19 6ZM17 26C17 25.4477 17.4477 25 18 25 18.5523 25 19 25.4477 19 26 19 26.5523 18.5523 27 18 27 17.4477 27 17 26.5523 17 26ZM6 19C5.44772 19 5 19.4477 5 20 5 20.5523 5.44772 21 6 21 6.55228 21 7 20.5523 7 20 7 19.4477 6.55228 19 6 19ZM27 18C27 18.5523 26.5523 19 26 19 25.4477 19 25 18.5523 25 18 25 17.4477 25.4477 17 26 17 26.5523 17 27 17.4477 27 18ZM25 11C25.5523 11 26 10.5523 26 10 26 9.44771 25.5523 9 25 9 24.4477 9 24 9.44771 24 10 24 10.5523 24.4477 11 25 11Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsOccupancy is a generated icon component.
 */
let IconRmsOccupancy = IconRmsOccupancy_1 = class IconRmsOccupancy extends IconBaseElement {
    render() {
        return html `${IconRmsOccupancy_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsOccupancy.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsOccupancy = IconRmsOccupancy_1 = __decorate([
    customElement('zui-icon-rms-occupancy')
], IconRmsOccupancy);
export { IconRmsOccupancy };
